import React, {Component} from "react";
import moment from "moment";
import momentTz from "moment-timezone";
import DayPicker from "react-day-picker";

export function defaultDateTime() {
    return {
        asEntered: {
            date: moment().format(dateFormat),
            time: moment().format(timeFormat),
            timezone: determineTimezone()
        },
        instant: moment().toISOString()
    };
}

function determineTimezone() {
    return moment.tz.guess();
}

const dateFormat = "Do MMMM YYYY";
const timeFormat = "HH:mm";
const dateTimeFormat = dateFormat + " " + timeFormat;

function toInstant(value) {
    const dateString = value.date + " " + value.time;
    const parsed = moment.tz(dateString, dateTimeFormat, value.timezone);
    if (!parsed.isValid()) {
        return null;
    }
    return parsed.toISOString();
}

const timezoneStyles = {
    maxWidth:"13em",
    overflow:"hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display:"inline-block",
    fontSize: "85%",
    color: "#aaa",
    marginLeft: "1em"
};

class DateTime extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDatePicker: true
        };

        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    render() {
        return (
            <div style={{display: "inline-block"}}>
                <input id={this.props.id}
                       ref="dateinput"
                       className="x-date idea-attribute__input"
                       onChange={event => {
                            const asEntered = { date: event.currentTarget.value, time: this.props.value.time, timezone: determineTimezone()};
                            this.props.onChange({ asEntered, instant: toInstant(asEntered) })
                       }}
                       onFocus={() => this.showDatePicker()}
                       onKeyDown={event => event.key === "Tab" && this.hideDatePicker()}
                       value={this.props.value.date}
                       style={{width: "10.5em"}}/>
                { this.state.showDatePicker === true ?
                    <div ref="calendar"
                         style={{
                             position: "absolute",
                             marginLeft: "-10.5em",
                             marginTop: "2.5em",
                             display: "inline-block",
                             backgroundColor: "white",
                             boxShadow: "0px 0px 25px 0px rgba(0,0,0,0.5)",
                             zIndex: "100"
                         }}>
                        <DayPicker tabIndex="-1"
                                   onDayClick={(e, day) => {
                                       const date = moment(day).format(dateFormat);
                                       const asEntered = { date, time: this.props.value.time, timezone: determineTimezone()};
                                       this.hideDatePicker();
                                       this.props.onChange({ asEntered, instant: toInstant(asEntered) })
                                   }}/>
                    </div> : undefined }
                &nbsp;at&nbsp;
                <input className="x-time idea-attribute__input"
                       onChange={event => {
                            const asEntered = { date: this.props.value.date, time: event.currentTarget.value, timezone: determineTimezone()};
                            this.props.onChange({ asEntered, instant: toInstant(asEntered) })
                       }}
                       value={this.props.value.time}
                       style={{width: "5.5em"}}/>
                       <span className="x-timezone" style={timezoneStyles}>{this.props.value.timezone}</span>
            </div>
        );

    }

    componentDidMount() {
        document.addEventListener("click", this.handleDocumentClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const calendar = this.refs.calendar;

        if(!calendar) return;

        const outsideTheCalendar = !calendar.contains(e.target);
        const onTheDateInput = e.target === this.refs.dateinput;

        if (outsideTheCalendar && !onTheDateInput) {
            this.hideDatePicker();
        }
    }

    hideDatePicker() {
        this.setState({
            showDatePicker: false
        });
    }

    showDatePicker() {
        this.setState({
            showDatePicker: true
        });
    }
}

DateTime.propTypes = {
    value: React.PropTypes.shape({
        date: React.PropTypes.string,
        time: React.PropTypes.string,
        timezone: React.PropTypes.string
    }),
    onChange: React.PropTypes.func
};

export default DateTime;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/DateTime.js
 **/